import {
  SHOPHISTORY_CREATE, SHOPHISTORY_CREATE_SUCCESS, SHOPHISTORY_CREATE_FAILURE,
  SHOPHISTORY_ALL_UPDATE, SHOPHISTORY_ALL_UPDATE_SUCCESS, SHOPHISTORY_ALL_UPDATE_FAILURE,
  SHOPHISTORY_CANCEL, SHOPHISTORY_CANCEL_SUCCESS, SHOPHISTORY_CANCEL_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    shopHistoryNotify: null
  },
  getters: {
    shopHistoryNotify: state => {
      return state.shopHistoryNotify
    }
  },
  actions: {
    [SHOPHISTORY_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/shop_histories/', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHOPHISTORY_CREATE_FAILURE, res.data)
            } else {
              commit(SHOPHISTORY_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [SHOPHISTORY_ALL_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/shop_histories/all_update', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHOPHISTORY_ALL_UPDATE_FAILURE, res.data)
            } else {
              commit(SHOPHISTORY_ALL_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [SHOPHISTORY_CANCEL] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/shop_histories/cancel', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOPHISTORY_CANCEL_FAILURE, res.data)
          } else {
            commit(SHOPHISTORY_CANCEL_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOPHISTORY_CREATE_SUCCESS] (state, data) {
      console.log('SHOPHISTORY_CREATE_SUCCESS')
      data.callback()
    },
    [SHOPHISTORY_CREATE_FAILURE] (state, data) {
      console.log('SHOPHISTORY_CREATE_FAILURE')
      state.shopHistoryNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.shopHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [SHOPHISTORY_ALL_UPDATE_SUCCESS] (state, data) {
      console.log('SHOPHISTORY_ALL_UPDATE_SUCCESS')
      data.callback()
    },
    [SHOPHISTORY_ALL_UPDATE_FAILURE] (state, data) {
      console.log('SHOPHISTORY_ALL_UPDATE_FAILURE')
      state.shopHistoryNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.shopHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [SHOPHISTORY_CANCEL_SUCCESS] (state, data) {
      console.log('SHOPHISTORY_CANCEL_SUCCESS')
      if (data.data.already_delete && data.callback) {
        data.callback()
      } else {
        window.location.reload(false)
      }
    },
    [SHOPHISTORY_CANCEL_FAILURE] (state, data) {
      console.log('SHOPHISTORY_CANCEL_FAILURE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shophistory-edit.js